<div class="w-full h-full flex items-center justify-center">
    <div class=" search-container w-[85vw] h-[70vh]">
        <div class=" text-center flex flex-col justify-center pt-20">
            <div class="max-w-2xl mx-auto text-center">
                <p class="main-title font-semibold text-gray-900 mb-4 mt-4">
                    <span class="highlight-icd">ICD</span> 
                    <span class="highlight-xanh-y-te"> Smart Search</span>
                </p>
                <p class="sub-title text-gray-900 mb-4">
                    Tìm kiếm thông tin
                    <span class="highlight-nhanh-chong">nhanh chóng</span> -
                    <span class="highlight-thong-minh">thông minh</span> - 
                    <span class="highlight-tien-loi">tiện lợi</span>
                </p>
            </div>
            <div class="flex items-center justify-center ">
                <div #boxSearch id="box-search" class="bar bg-white flex items-center relative">
                    <div class="w-[50px] h-full flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            class="translate-x-[2px]"
                            height="24"
                            fill="#5F6368"
                        >
                            <path
                                d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                            />
                        </svg>
                    </div>
                    <input
                        autocomplete="off"
                        #searchInput
                        [(ngModel)]="searchQuery"
                        (input)="handleInputChange()"
                        (keydown)="handleKeyDown($event)"
                        id="searchGlobal"
                        class="searchbar"
                        placeholder="Nhập bất kì từ khóa nào để tìm kiếm "
                        type="text"
                        title="Search"
                    />
                    <div
                    (click)="handleDelInput()"
                    [ngClass]="{ hidden: searchQuery.length <= 0, flex: searchQuery.length > 0 }"
                    class="w-[50px] h-full items-center justify-center cursor-pointer"
                >
                    <svg
                        focusable="false"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        *ngIf="!isLoading"
                    >
                        <path
                            fill="#70757a"
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                        ></path>
                    </svg>
                    <div class="spinner-container">
                        <div class="spinner" *ngIf="isLoading"></div>
                    </div>
                </div>

                    <div
                        #recommendBox
                        id="recommend-box"
                        class="recommend-box hidden w-full bg-white absolute top-[45px]"
                    >
                        <ul class="w-full pt-2 border-t">
                            <li
                                *ngFor="let item of searchRecommend; let i = index"
                                class="h-[30px] rec-item"
                                [class.activate]="i === selectedIndex"
                                (click)="onSearchItemClick(item)"
                            >
                                <div class="w-full h-full flex items-center">
                                    <div class="w-[50px] h-full flex items-center justify-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            class="translate-x-[2px]"
                                            height="24"
                                            fill="#5F6368"
                                        >
                                            <path
                                                d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                                            />
                                        </svg>
                                    </div>
                                    {{ item }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>  
        <!-- Ngay bên dưới thanh nhập liệu, có các nút tag đẹp mắt chứ thông tin "ICD-10 vol 1", "ICD-10 vol 3", "ICD-9 CM", "Tiếng Anh", "Tiếng Việt" -->
        <div class="flex items-center justify-center mt-4">
            <div class="tag-container">
                <div class="tag-item">
                    <span class="tag-text">ICD-10 vol 1</span>
                </div>
                <div class="tag-item">
                    <span class="tag-text">ICD-10 vol 3</span>
                </div>
                <div class="tag-item">
                    <span class="tag-text">ICD-9 CM</span>
                </div>
                <div class="tag-item">
                    <span class="tag-text">Tiếng Anh</span>
                </div>
                <div class="tag-item">
                    <span class="tag-text">Tiếng Việt</span>
                </div>
            </div>
        </div>
    </div>
</div>
